import Stomp, { Client } from 'webstomp-client';
import SockJS from 'sockjs-client';
import { cacheStompTXCB } from '../features/socketSlice';
import store from '../cache/store';
interface TXCB {
    stompClient: Client | null;
    connect: () => void;
    disconnect: () => void;
    sendMessage: (topic: string, payload: any) => void;
}

const txcbSocket: TXCB = {
    stompClient: null,
    connect: () => {
        const urlTXCB = process.env.REACT_APP_TXCB_MINIGAME;
        const { apiToken } = store.getState().auth;
        const url = `${urlTXCB}/websocket/ws-taixiu`;
        const socket = new SockJS(url);
        const stompClient = Stomp.over(socket);
        txcbSocket.stompClient = stompClient;
        stompClient.debug = () => {};
        const header = {
            Authorization: apiToken || '',
        };
        stompClient.connect(header, () => {
            store.dispatch(cacheStompTXCB(stompClient));
        });
    },
    disconnect: () => {
        if (txcbSocket.stompClient) {
            txcbSocket.stompClient.disconnect();
        }
    },
    sendMessage: (topic: string, payload: any) => {
        if (txcbSocket.stompClient && txcbSocket.stompClient.connected) {
            const { apiToken } = store.getState().auth;
            const header = {
                Authorization: apiToken || '',
            };
            txcbSocket.stompClient.send(
                topic, // destination
                JSON.stringify(payload), // body
                header // header
            );
        }
    },
};

export default txcbSocket;
